<div class="qds-header" *ngIf="isLoggedIn">
  <div class="header-content">
    <div class="title">
      <qds-title layer="main" level="section" alignment="start" title="Eliwell Air Cloud Application" class="qds-title">
        Eliwell Air Cloud Application
      </qds-title>
    </div>
    <div class="toolbar">
      <div class="toolbar-content">
        <!-- <div class="nav-icon">
          <a class="navbar__link navbar-icon">
           <qds-icon name="input-search" icon-library="default"  class="qds-icon"> </qds-icon>
          </a>
        </div> -->
        <div class="nav-icon user-info" #userInfoRef (click)="toggleUserMenu()">
          <a class="navbar__link navbar-icon">
           <qds-icon name="person" icon-library="default" class="qds-icon" title="User Profile"> </qds-icon>
          </a>
          <span class="user-name" title="{{loggedInUser || user.email || 'IDMS user'}}">{{loggedInUser || user.email || 'IDMS user'}}</span>
          <qds-icon name="chevron-down" size="small" icon-library="default" class="qds-icon user-menu-chevron" [ngClass]="{'rotated': showUserMenu}"></qds-icon>
        </div>
        <div class="nav-icon">
          <a class="navbar__link navbar-icon">
            <qds-icon name="bell-waves" icon-library="default"  class="qds-icon"> </qds-icon>
          </a>
        </div>
        <!-- <div class="nav-icon">
          <a class="navbar__link navbar-icon">
            <qds-icon name="question-mark" icon-library="default"  class="qds-icon"> </qds-icon>
          </a>
        </div> -->
        <!-- <div class="nav-icon">
          <a class="navbar__link navbar-icon">
            <qds-icon name="information-circle-solid" icon-library="default"  class="qds-icon"> </qds-icon>
          </a>
        </div> -->

        <!-- Logout moved to user context menu -->

        <!-- <div class="nav-icon">
          <a
         
          class="navbar__item navbar__link navbar-icon"
          (click)="toggleTheme()"
          title="{{ theme() === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode' }}"
        >
          <qds-icon
            class="qds-icon"
            name="{{ theme() === 'light' ? 'moon' : 'sun' }}"
            icon-library="default"
          ></qds-icon>
        </a>
        </div> -->
        <div class="se-logo-header">
          <div data-color="White" data-logotypes="Schneider Electric" class="logo-panel">
            <img class="logo" src="assets/logo-se-light.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="user-context-menu" *ngIf="showUserMenu" [style.top.px]="userMenuPosition.top" [style.left.px]="userMenuPosition.left">
    
    <div class="user-context-menu-item" (click)="navigateToUrl(urls.profileUpdate)">
      <qds-icon name="person" icon-library="default" class="qds-icon"></qds-icon>
      <span>Profile Update</span>
    </div>
    <div class="user-context-menu-item" (click)="navigateToUrl(urls.pwdUpdate)">
      <qds-icon name="eye" icon-library="default" class="qds-icon"></qds-icon>
      <span>Change Password</span>
    </div>
    <div class="user-context-menu-item" (click)="navigateToUrl(urls.emailUpdate)">
      <qds-icon name="envelope" icon-library="default" class="qds-icon"></qds-icon>
      <span>Change Email</span>
    </div>
    <div class="user-context-menu-item" (click)="logout()">
      <qds-icon name="arrow-left-out-rectangle" icon-library="default" class="qds-icon"></qds-icon>
      <span>Logout</span>
    </div>
  </div>
</div>
